<template>
  <div class="block-f">
    <div class="block-f__content" data-aos="fade-up">
      <div class="block-f__letter letter letter--yellow">Ф.</div>
    </div>
    <div class="block-f__slider">
      <div class="swiper-container swiper-gallery-2">
        <div class="swiper-wrapper">
          <div class="swiper-slide"><img src="../assets/img/block-f-1-m.jpg" alt=""></div>
          <div class="swiper-slide"><img src="../assets/img/block-f-2-m.jpg" alt=""></div>
          <div class="swiper-slide"><img src="../assets/img/block-f-3-m.jpg" alt=""></div>
          <div class="swiper-slide"><img src="../assets/img/block-f-4-m.jpg" alt=""></div>
        </div>
      </div>
    </div>
    <div class="block-f__top">
      <div class="block-f__title" data-aos="fade-up">Фокстрот</div>
      <div class="block-f__text" data-aos="fade-up">Зародившись в десятые годы в США, фокстрот приобрёл чрезвычайную популярность в первые же годы существования СССР. Фокстрот танцевали везде: в кафе и домашних салонах; его даже включали в свои спектакли Всеволод Мейерхольд и Николай Фореггер. С закатом «кафейной культуры» фокстрот постепенно был подвергнут гонениям за мещанство и сексуальность и попал под запрет. </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
export default {
  name: 'BlockF',
  mounted() {
    new Swiper('.swiper-gallery-2', {
      loop: true,
     autoplay: {
       delay: 2500,
     },
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
    });
  }
}
</script>

<style lang="sass">
  @media screen and (max-width: 999px)
    .block-f
      position: relative
      z-index: 900
      &:after
        display: none
    .block-f__text
      font-size: vwm(17px)
      text-align: left
      line-height: vwm(22px)
      width: 92vw
      margin: auto
      margin-top: vwm(51px)
      br
        display: none
    .block-f__title
      margin-left: vwm(17px)
      text-align: left
      font-size: vwm(60px)
      margin-top: vwm(14px)
    .block-f__top
      flex-direction: column
    .block-f__content
      position: relative !important
      z-index: 2200 !important
    .block-f__letter
      margin-top: vwm(-132px)
      margin-left: vwm(165px)
    .block-f__slider
      width: 100vw
      background-image: url(../assets/img/lenta-m-2.png)
      background-repeat: no-repeat
      background-position: 50% 50%
      height: vwm(270px)
      background-size: 100vw
      margin-top: vwm(-80px)
      img
        width: vwm(356px)
        margin-top: vwm(22px)
        margin-left: vwm(9px)
</style>
